import Cookies from 'universal-cookie';
import { ProjectType } from '../api/projects-api';
 
export const cookies = new Cookies();

export const saveTokenInCookies = (token: string, expiresAt: Date) => {
  cookies.set('token', token, { path: '/', maxAge: 7000 })
  //cookies.addChangeListener(() => alert('cooky has been changed'))
  //cookies.set('token', token, { path: '/' })
  cookies.set('expiresAt', expiresAt, { path: '/' })
}
export const removeTokenFromCookies = () => {
  cookies.remove('token', {path: '/'})
}

export const setProjectsInCookies = (projects: Array<ProjectType>) => {
  const projectNames = projects.map(pr => {
    let container: any = {}
    container.projectName =  pr.projectName
    container.projectId = pr.id
    return container
  })
  cookies.set('projects', projectNames, {path: '/'})
}

export const removeProjectNamesFromCookies = () => {
  cookies.remove('projects', {path: '/'})
}

export const getProjectNamesFromCookies = () => {
  return cookies.get('projects')
}

export const setLocation = (projectName: string, projectId: number, itemId?:number) => {
  cookies.set('projectName', projectName, {path: '/'} )
  cookies.set('projectId', projectId, {path: '/'} )
  cookies.set('itemId', itemId, {path: '/'} )
}
export const getLocation = () => {
 let projectName = cookies.get('projectName')
 let projectId = cookies.get('projectId')
 let itemID = cookies.get('itemId')
 return {projectName, projectId, itemID}
}
export const removeLocationFromCookies = () => {
  cookies.remove('projectName', {path: '/'})
  cookies.remove('projectId', {path: '/'})
  cookies.remove('itemId', {path: '/'})
}

export const setCurrentLocation = (currentLocation: string) => {
  console.log('SETcurrentLocation', currentLocation)
  cookies.set('currentLocation', currentLocation, {path: '/'})
}
export const getCurrentLocation = () => {
  let loc = cookies.get('currentLocation')
  console.log('GETcurrentLocation', loc)
  return loc
}
export const removeCurrentLocation = () => {
  cookies.remove('currentLocation', {path: '/'})
}

export const setRoleinCookies = (isAdmin: boolean) =>  {
  cookies.set('role', isAdmin, {path: '/'})
}
export const getRoleFromCookies = () =>  {
  return cookies.get('role')
}
export const removeRoleinCookies = () =>  {
  cookies.remove('role', {path: '/'})
}
